export const PoemCrossfire = () => {
    return (
        <div id="025" className="">
            <p>glowing yellow light horizon</p>
            <p>and it looks like either the end of the world</p>
            <p>or the beginning of it.</p>
            <p>no in betweens. never.</p>
            <p>every single thing likes having a trajectory,</p>
            <p>and there's a feeling that never goes away</p>
            <p>that you're always in the middle of one of them,</p>
            <p>unseen path, fate like a</p>
            <p>sniffer police dog,</p>
            <p>the burden of being is about 10% physical weight</p>
            <p>and 90% getting caught in</p>
            <p>the crossfire of other living beings,</p>
            <p>words like radar radio waves.</p>
            <p>each one of us, an island,</p>
            <p>each one of us, a nuclear silo,</p>
            <p>every zone like a war zone,</p>
            <p>a "birth and/or death" zone,</p>
            <p>the present scatters. words like signals.</p>
            <p>everything incomplete,</p>
            <p>rows of glowing screens in an underground bunker.</p>
            <p>in the dark, there</p>
            <p>aren't many things to do but cling to the unknown,</p>
            <p>but on the surface -</p>
            <p>every living body crying out for attention,</p>
            <p>despite the sunlight</p>
            <p>even in the brightest days the future remains shrouded,</p>
            <p>a blind spot for every conjecture,</p>
            <p>here we are, in between the start and the end,</p>
            <p>on an axis picked out of a billion other,</p>
            <p>i said there are no in betweens, that's a lie.</p>
            <p>of course there's always</p>
            <p>an in between to be in.</p>
        </div>
    );
};
